import { render, staticRenderFns } from "./customerizedVideoPlayer.vue?vue&type=template&id=0b4c7d3d&scoped=true"
import script from "./customerizedVideoPlayer.vue?vue&type=script&lang=js"
export * from "./customerizedVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./customerizedVideoPlayer.vue?vue&type=style&index=0&id=0b4c7d3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c7d3d",
  null
  
)

export default component.exports